import { BookDescriptionProvider } from "~/contexts/book-description-context";
import { MulticolumnBasePanel } from "~/components/base-panel/multicolumn-base-panel";
import { DatabaseDescription } from "./components/database-description/database-description";
import { GenerateDescription } from "./components/generate-description/generate-description";
import { DescriptionsList } from "./components/descriptions-list";

export const BookDescriptionTab = () => {
  return (
    <BookDescriptionProvider>
      <MulticolumnBasePanel
        gridTemplateColumns="300px 1fr 1fr"
        columns={[
          {
            component: <DescriptionsList />,
          },
          {
            component: <DatabaseDescription />,
          },
          {
            component: <GenerateDescription />,
          },
        ]}
      />
    </BookDescriptionProvider>
  );
};
